/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { ConfigurationRequestsStore } from '../configuration-requests-store';

export const ConfigurationRequestsStoreContext = createContext<ConfigurationRequestsStore>({} as ConfigurationRequestsStore);
